module.exports = __webpack_public_path__ + "img/u115.670dac41.png";